var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMelonit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28,
    height: 21,
    viewBox: "0 0 28 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M23.676 10.399H2.792V1.396C2.792.625 2.166 0 1.396 0 .626 0 0 .625 0 1.396V17.584c0 1.081.877 1.958 1.957 1.958h24.766v-6.097c0-1.682-1.364-3.046-3.047-3.046",
    transform: "translate(.125 .523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4A8254",
    d: "M8.819 6.76c0 1.499-1.215 2.713-2.713 2.713S3.393 8.26 3.393 6.761c0-1.499 1.215-2.713 2.713-2.713S8.82 5.262 8.82 6.76",
    transform: "translate(.125 .523)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#69B045",
    d: "M24.29 8.232L10.45 3.89c-.358-.148-.753.117-.753.505v4.89h14.387c.598 0 .76-.825.207-1.052",
    transform: "translate(.125 .523)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMelonit);
export default __webpack_public_path__ + "static/media/melonit.51cd75aad314e181e3ab84dae26b4252.svg";
export { ForwardRef as ReactComponent };